import { useGeneratedPricingVariantPackCostChangeDataQuery } from '@sales-portal/domain/pricing/screens/management/blocs/documents/variant-pack-cost-change-data.generated';
import { useMemo } from 'react';

/**
 * Hook to load cost change data for variant packs for the current business organization.
 *
 * @returns An object containing the query data and loading state.
 *
 * @example
 * ```typescript
 * const { data, loading } = useVariantPackCostChangeDataLoader();
 * ```
 */
export const useVariantPackCostChangeDataLoader = () => {
  const { data, loading, error, refetch } =
    useGeneratedPricingVariantPackCostChangeDataQuery({
      notifyOnNetworkStatusChange: true,
    });

  return useMemo(
    () => ({
      data,
      error,
      loading,
      refetch,
    }),
    [data, error, loading, refetch],
  );
};
